import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_single');

    return (
        <div className="sp-220-single-J">
            <p className="title">{t('J_title')}</p>
            <ul className="inner-box">
                {new Array(10).fill(1).map((_: any, k: number) => {
                    return locale === 'us' && k === 5 ? null : (
                        <li className="item" key={k}>
                            <p className="item-title">{t(`J_${k + 1}_title`)}</p>
                            <p className="item-desc">{t(`J_${k + 1}_desc`)}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
